import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Routes from "routes";
import Header from "components/Header";
import HeaderTheme2 from "components/HeaderTheme2";
import Footer from "components/Footer";
import FooterTheme2 from "components/FooterTheme2";
import BackToTop from "components/BackToTop";
import {
  getCommonDetails,
  selectCurrentStore,
  getUserDetails,
  getClientDetails,
  getcouponDepartmentDetails
} from "redux/actions";
import useStoreList from "hooks/useStoreList";
import { useLocation } from "react-router-dom";
import { getLocalStorageValue, isCostBoss, setLocalStorageValue } from "config/helper";
import MobileBottomSticky from "components/MobileBottomSticky";
import Loader from "components/Loader";
import Favicon from 'react-favicon';
import ErrorBoundary from "components/Common/ErrorBoundary";
import { SeoConfig } from 'components/SeoConfig';

const Layout = () => {
  const dispatch = useDispatch();
  useStoreList();
  const { pathname } = useLocation();
  const storeId = getLocalStorageValue("selected-store-id");
  const clientId = getLocalStorageValue("RSAclient-id");
  const theme = getLocalStorageValue("theme-name");
  const userToken = getLocalStorageValue("user-token");
  const memberNumber = getLocalStorageValue("member-number");
  const aogEndPointURL = getLocalStorageValue("api-end-point-aog");

  const commonDetailsDataLoading = useSelector(
    ({ common }) => common.commonDetailsDataLoading
  );
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);
  const { clientDetailsLoading } = useSelector(({ user }) => user);
  const { theme_type } = useSelector(
    ({ common }) => common.commonDetailsData.header_section || {}
  );

  const commonDetailsData = useSelector(
    ({ common }) => common.commonDetailsData
  );

  const { storeListData, currentStoreID } = useSelector(({ store }) => store);
  const faviconIconUrl = commonDetailsData?.header_section?.rsa_client_favicon || "%PUBLIC_URL%/rsa-favicon.png";

  useEffect(() => {
    if (faviconIconUrl) {
      const faviconUrl = faviconIconUrl.replace("%PUBLIC_URL%", window.location.origin);
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = faviconUrl;

      let appleTouchIcon = document.querySelector("link[rel~='apple-touch-icon']");
      if (!appleTouchIcon) {
        appleTouchIcon = document.createElement("link");
        appleTouchIcon.rel = "apple-touch-icon";
        document.head.appendChild(appleTouchIcon);
      }
      appleTouchIcon.href = faviconUrl;
    }
  }, [faviconIconUrl]);

  useEffect(() => {
    const prePageUrl = getLocalStorageValue("current_page_url") || "";
    setLocalStorageValue("pre_page_url", prePageUrl);
    setLocalStorageValue("current_page_url", pathname);
  }, [pathname]); // eslint-disable-line
  /* 
    useEffect(() => {
      if (is_clear_localstorage) {
        if (is_clear_localstorage !== getLocalStorageValue("is_clear_localstorage")
        ) {
          const store = getLocalStorageValue("selected-store-id");
          localStorage.clear();
          setLocalStorageValue("selected-store-id", store);
          setLocalStorageValue("is_clear_localstorage", is_clear_localstorage);
          window.location.reload();
        }
      }
    }, [is_clear_localstorage]); // eslint-disable-line */

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }, [pathname]);

  useEffect(() => {
    // This will run when the page first loads and whenever the title changes
    document.title = window.location.hostname;
  }, [window.location.hostname]); // eslint-disable-line
  useEffect(() => {
    let subdomain = window.location.hostname;
    if (window.location.hostname == "localhost") {
      // subdomain = "www.igamarkets.com";
      // subdomain = "www.hendersonpigglywiggly.com";
      // subdomain = "www.ongrocerycart.us";
      // subdomain = "aogdemo.web.app";
      // subdomain = "shopholidaymarket.web.app";
      // subdomain = "www.mathernes.com";
      // subdomain = "aog-ecom-theme2.web.app";
      // subdomain = "www.vowellsmarketplace.com";
      // subdomain = "www.wedigthepig.com";
      // subdomain = "aogclientdemo.web.app";
      // subdomain = "www.ongroceryqa.com";
      // subdomain = "teals--market.web.app";
      // subdomain = "www.ongrocerystaging2.com";
      // subdomain = "www.valliproduce.com";
      // subdomain = "keyur-test.web.app";
       // subdomain = "www.valliprodluce.com";
       
       const env = process.env.REACT_APP_ENV;
       if (env === "beta") {
        //  subdomain = "keyur-test.web.app";
         subdomain = "redners-markets-beta.web.app";
        } else if (env === "staging") {
          // subdomain = "www.edwardsfoodgiant.com";
          // subdomain = "www.hardings.com";
          // subdomain = "www.kirbyfoods.com";
          // subdomain = "www.kirbyfoods.com";
          // subdomain = "www.tealsmarket.com";
          // subdomain = "www.rednermarkets.com";
          subdomain = "redners-markets.web.app";
          // subdomain = "www.shopcostboss.com";
      } else if (env === "prod") {
          subdomain = "www.rednermarkets.com";
        subdomain = "coupons.thepigbham.com";
        subdomain = "www.fresh-value.com";
      }
    }

    const body = {
      subdomain: subdomain,
      // subdomain: "www.veritratechnologies.com",
      // subdomain: "dev.d1vjfwhpzfikie.amplifyapp.com",
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : ""
    };
    !clientId && !aogEndPointURL && dispatch(getClientDetails(body));
  }, [clientId]); // eslint-disable-line

  useEffect(() => {
    clientId && aogEndPointURL && dispatch(getUserDetails());
  }, [clientId, aogEndPointURL]); // eslint-disable-line

  useEffect(() => {
    if (clientId && aogEndPointURL && storeId) {
      const body = {
        RSAClientId: clientId,
        ClientStoreId: +storeId,
        AppName: isUserLoggedIn ? "shop" : "",
        member_number: isUserLoggedIn ? memberNumber : "",
        user_token: isUserLoggedIn ? userToken : "",
        Version: isUserLoggedIn ? "1" : "",
        DeviceType: isUserLoggedIn ? "web" : ""
      };
      Object.keys(commonDetailsData).length === 0 &&
        dispatch(getCommonDetails(body));
    }
  }, [clientId, aogEndPointURL, storeId]); // eslint-disable-line

  useEffect(() => {
    if (clientId && aogEndPointURL && storeId) {
      const body = {
        RSAClientId: clientId,
        ClientStoreId: +storeId,
        AppName: isUserLoggedIn ? "shop" : "",
        member_number: isUserLoggedIn ? memberNumber : "",
        user_token: isUserLoggedIn ? userToken : "",
        Version: isUserLoggedIn ? "1" : "",
        DeviceType: isUserLoggedIn ? "web" : ""
      };
      dispatch(getcouponDepartmentDetails(body));
    }
  }, [clientId, aogEndPointURL, storeId]); // eslint-disable-line

  useEffect(() => {
    if (!storeId && !currentStoreID && !!storeListData.length) {
      let _selectedStore = storeListData[0];
      if (isCostBoss()) {
        _selectedStore = storeListData?.find(s => s.store_name_key === "dundalk-96")
        if (!_selectedStore) {
          _selectedStore = storeListData[0];
        }
      }
      dispatch(selectCurrentStore(_selectedStore));
      setLocalStorageValue("selected-store-id", _selectedStore.ClientStoreId);
    }
  }, [storeId, currentStoreID, storeListData]); // eslint-disable-line

  return !commonDetailsDataLoading &&
    !clientDetailsLoading &&
    clientId &&
    aogEndPointURL ? (
    <ErrorBoundary boundaryName="Layout-Root">
      <SeoConfig />
      <div className={theme}>
        <Favicon url={faviconIconUrl} />
        <ErrorBoundary boundaryName="Header">
          {theme_type === "2" ? <HeaderTheme2 /> : <Header />}
        </ErrorBoundary>
        <div style={{minHeight: '800px'}}>
          <ErrorBoundary boundaryName="Routes">
            <Routes />
          </ErrorBoundary>
        </div>
        <ErrorBoundary boundaryName="Footer">
          {theme_type === "2" ? <FooterTheme2 /> : <Footer />}
        </ErrorBoundary>

        {/* <Cookie /> */}
        <BackToTop />
        {theme_type === "2" ? <MobileBottomSticky /> : ""}
      </div>
    </ErrorBoundary>
  ) : (
    <div className="loader-container">
      <Loader />
    </div>
  );
};

export default React.memo(Layout);
